<!--  -->
<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="name"
        label="成员名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="employee_no"
        label="编号"
        width="300"
        align="center"
      />
      <el-table-column
        prop="errmsg"
        label="绑定备注"
        align="center"
      />
    </el-table>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      tableData: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(arr) {
      console.log('arr', arr)
      this.tableData = arr
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
